import React, { Fragment } from 'react'
import QRCode from 'qrcode.react'
// import Button from 'react-bootstrap/Button'
// import Tooltip from "react-bootstrap/Tooltip"

import WithOverlay from "../WithOverlay.js"
import { getLog } from '../../helpers/helpers.js'
import "./popup.css"
import "../../resources/css/global.css"
import { appConfig } from '../../config.js'
import { ButtonPrimary, ButtonPrimaryOutlined } from '../../components/Buttons.js'




/** props:
        - children (jsx)            html code to display the button
        - description (str)         text to show with the hover description
        - onClick (function)        function to trigger on click
        - forceshow (bool)          affiche tout le temps sinon que en onMouseOver
*/
class ButtonDescription extends React.Component {
    constructor(props) {
        super(props)
        this.show_description = this.show_description.bind(this)
        this.hide_description = this.hide_description.bind(this)
        this.myRef = React.createRef()
    }
    show_description() {
        this.myRef.current.style.visibility = "visible"
    }
    componentDidMount() {
        if (this.props.forceshow === "true" || this.props.forceshow === true) {
            this.show_description()
        } else {
            this.myRef.current.style.visibility = "hidden"
        }
    }
    hide_description() {
        if (this.props.forceshow !== "true" && this.props.forceshow !== true) {
            //console.log("hide description")
            this.myRef.current.style.visibility = "hidden"
        }
    }

    render() {
        return (
            <Fragment>
                <ul style={{
                    listStyleType: "none",
                    display: "inline-grid",
                    padding: "0px 2px",
                }}>
                    <li>
                        <button onClick={this.props.onClick}
                            onMouseOver={this.show_description}
                            onMouseOut={this.hide_description}
                            style={{
                                cursor: "pointer",
                                backgroundColor: "Transparent",
                                border: "none",
                                color: "white"
                            }}>
                            {this.props.children}
                        </button>
                    </li>
                    <li>
                        <span ref={this.myRef}
                            style={{
                                fontSize: "13px",
                                margin: "10px 0px 0px -21px",
                                visibility: "hidden",
                                position: "absolute",
                                zIndex: "99999",
                                backgroundColor: "#555",
                                color: "#fff",
                                textAlign: "center",
                                borderRadius: "6px",
                                padding: "4px"
                            }}>
                            {this.props.description}
                        </span>
                    </li>
                </ul>
            </Fragment>
        )
    }
}



class ButtonDescription2 extends React.Component {
    render() {
        return (
            <WithOverlay forceshow={this.props.forceshow} text={this.props.description}>
                {this.props.children}
            </WithOverlay>
        )
    }
}



export class SlidePopup extends React.Component {
    /*  props:
            - children
                JSX that says what to display in the popup
            - hideButton: defaults to false, hides the button.
            - onButtonClick
                says what to do when button is clicked (like make popup disappear in parent render)
            - (optionnel) buttonText
                to customize the button text, otherwise "Fermer" by default
            - (optional) fullWidth  => make full width instead of only slide width
            - (optional) transparent - leave ~10% transparency on background color
    */
    constructor(props) {
        super(props)
        this.state = {
            hidePopup: false,
        }
        this.onHidePopup = this.onHidePopup.bind(this)
    }
    onHidePopup() {
        this.setState({
            hidePopup: true,
        });
    }
    render() {
        if (this.state.hidePopup) return null

        // button action is "close" or what was provided in props
        let onClick = this.onHidePopup
        if (this.props.onButtonClick) onClick = this.props.onButtonClick

        var buttonjsx = ""
        if (!this.props.hideButton) {
            buttonjsx = <>
                <ButtonPrimaryOutlined onClick={onClick}>
                    {this.props.buttonText ? this.props.buttonText : "Fermer"}
                </ButtonPrimaryOutlined><br />
            </>
        }
        /*
        return (
            <Fragment>
                <div className="popup" />
                <div className='popup_content'>  
                    <div className="popup_content_inner">
                        {this.props.content} 
                        <br/>
                        {buttonjsx}
                    </div>
                </div>
            </Fragment>
        )
        */
        var str_classes = " popup "
        if (this.props.fullWidth) str_classes += " popup_fullwidth "
        if (this.props.transparent) str_classes += " popup_transparent "

        // if a specific button is provided, we might want to also add a second "close" button
        const add_second_close_button = false  // TODO make this provided through props
        let second_button = null
        if (this.props.onButtonClick && add_second_close_button) {
            second_button =
                <ButtonPrimary onClick={this.onHidePopup}>
                    Fermer
                </ButtonPrimary>
        }

        let backgroundColor = appConfig.theme.backgroundColorDarker1

        return (
            <div className={str_classes} style={{ backgroundColor: backgroundColor }}>
                <div className='popup_inner' style={{ wordBreak: "break-word" }}>
                    <br />
                    {this.props.children} <br /><br />
                    {buttonjsx}
                    &nbsp; &nbsp;
                    {second_button}
                    <br /><br /><br /><br />
                </div>
            </div>
        )
    }
}



export class WithPopup extends React.Component {
    /*  props:
            - popupcontent (jsx)
                content of the popup when it displays after click on children
            - forceShow (boolean)
                true to force show the popup even before clicking
            - closePopupCallback (function, optional)
                optional callback function for when the popup is closed due to click on close button
            - buttonText (string, optional)
                a specific text for the button inside the popup, default: "Fermer"
            - fullWidth  (optional)
            - (optional) transparent - leave ~10% transparency on background color
        children:
            what to display when no popup, by default,
            you will be able to click on it to open the popup
    */
    constructor(props) {
        super(props)
        this.state = {
            showPopup: false,
            firstLoad: true,
        }
        this.togglePopup = this.togglePopup.bind(this)
        this.onClosePopup = this.onClosePopup.bind(this)
        //<h1>Click "Close Button" to hide popup</h1> 
    }
    togglePopup() {
        this.setState({
            showPopup: !this.state.showPopup,
            firstLoad: false,
        });
    }
    onClosePopup() {
        this.togglePopup()
        if (this.props.closePopupCallback) {
            this.props.closePopupCallback()
        }
    }
    render() {
        if (this.state.firstLoad && this.props.forceShow) {
            this.togglePopup()
        }
        return (
            <Fragment>
                {this.state.showPopup ?
                    <SlidePopup
                        fullWidth={this.props.fullWidth}
                        onButtonClick={this.onClosePopup}
                        buttonText={this.props.buttonText}
                        transparent={this.props.transparent}
                    >
                        {this.props.popupcontent}
                    </SlidePopup>
                    : null
                }
                <span onClick={this.togglePopup}>
                    {this.props.children}
                </span>
            </Fragment>
        )
    }
}


/*  props:
        - value
            the text to copy to clipboard
        - children
            the content of the button
*/
/*export class CopyButton extends React.Component {

    constructor(props) {
        super(props)
        this.copyelement = this.copyelement.bind(this)
        this.resetcopied = this.resetcopied.bind(this)

        this.duration_validation_message = 1500 //in ms

        this.state = { copied: false, }
    }
    copyelement() {
        var val = this.props.value
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(val)
        } else {
            var textarea = document.createElement("textarea")
            textarea.value = val
            textarea.style.position = "fixed"
            textarea.style.opacity = "0"
            document.body.appendChild(textarea)
            textarea.select()
            document.execCommand("copy")
            document.body.removeChild(textarea)
        }
        this.setState({ copied: true })
    }
    resetcopied() {
        setTimeout(function () {
            this.setState({ copied: false })
        }.bind(this),
            this.duration_validation_message
        );
    }
    render() {
        var mybutton = ""
        if (this.state.copied === false) {
            mybutton = <ButtonDescription
                description="Copier"
                onClick={this.copyelement}
                key="1">
                {this.props.children}
            </ButtonDescription>
        } else {
            this.resetcopied()
            mybutton = <ButtonDescription
                description="Copié avec succès!"
                forceshow="true"
                key="2"
                onClick={this.copyelement}>
                {this.props.children}
            </ButtonDescription>
        }
        return (
            <Fragment>
                {mybutton}
            </Fragment>
        )
    }
}
*/



/**  a simple copy icon that you users can click to copy text to pasteboard
 props:
    - value              the text to copy to clipboard
    - children          the content of the button
*/
export class CopyButton2 extends React.Component {
    constructor(props) {
        super(props)
        this.copyelement = this.copyelement.bind(this)
        this.resetcopied = this.resetcopied.bind(this)

        this.duration_validation_message = 1500 //in ms

        this.state = { copied: false, }
    }
    copyelement() {
        var val = this.props.value
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(val)
        } else {
            var textarea = document.createElement("textarea")
            textarea.value = val
            textarea.style.position = "fixed"
            textarea.style.opacity = "0"
            document.body.appendChild(textarea)
            textarea.select()
            document.execCommand("copy")
            document.body.removeChild(textarea)
        }
        this.setState({ copied: true })
    }
    resetcopied() {
        setTimeout(function() {
            this.setState({ copied: false })
        }.bind(this),
            this.duration_validation_message
        );
    }
    render() {
        var mybutton = ""
        if (this.state.copied === false) {
            mybutton = <ButtonDescription2
                description="Copier"
                key="1">
                {this.props.children}
            </ButtonDescription2>
        } else {
            this.resetcopied()
            mybutton = <ButtonDescription2
                description="Copié !"
                forceshow="true"
                key="2">
                {/* this.props.children */}
                <span style={{ color: "limegreen" }}>
                    copié <i className="fas fa-check" />
                </span>
            </ButtonDescription2>
        }
        return (
            <Fragment>
                <span style={{ cursor: "pointer" }} onClick={this.copyelement}>
                    {mybutton}
                </span>
            </Fragment>
        )
    }
}


function getQR_JSX(dataQR) {
    return (
        <Fragment>
            {dataQR}<br /><br />
            <QRCode value={dataQR}
                level="L"
                bgColor="white" fgColor="black"
                size={220}
                style={{ border: "10px solid white" }}
            />
        </Fragment>
    )
}


/**
 * display a text with a copy button
 * 
 * @param {string} value - content to display 
 * @param {boolean} noUserSelectAll - (optional) true to not force user to select all by default
 * @param {object} style - (optional) additional styles to apply to the span
 */
export class TextCopy extends React.Component {
    render() {
        // var button_copy = <i className='fas fa-copy' />
        var button_copy = <ButtonPrimaryOutlined >
            copier
        </ButtonPrimaryOutlined>

        let userSelect_type = "all" // default
        if (this.props.noUserSelectAll) userSelect_type = "default"

        return (<>
            <span style={{ userSelect: userSelect_type, ...this.props.style }}>
                {this.props.value}
            </span>
            <br />
            <CopyButton2 value={this.props.value}>
                {button_copy}
            </CopyButton2>
        </>)
    }
}



/**
 * display a text with a copy button and a QR generator button
 * 
 * @param {value} - content to display 
 */
export const TextCopyQR = (props) => {
    const function_id = "TextCopyQR"
    const log = getLog(function_id)

    // log("props.value = ",props.value)
    var button_qr = <i className="fas fa-qrcode" />

    return (
        <Fragment>

            <TextCopy value={props.value} />
            &nbsp; &nbsp;

            <WithPopup popupcontent={getQR_JSX(props.value)}>
                <span style={{ cursor: "pointer" }}>
                    <WithOverlay text="QR code">
                        {button_qr}
                    </WithOverlay>
                </span>
            </WithPopup>

        </Fragment>
    )
}


/*
BUT:

var button_copy = <i className='fas fa-copy' /> 
var button_qr = <i className="fas fa-qrcode" />

<span style={{userSelect: "all"}}>
    {this.props.value}
</span>

<ButtonDescription button={button_copy} description="Copier" onClick={this.copytext} />

<ButtonDescription button={button_qr} description="Afficher QR Code" onClick={this.showQRpopup} />

<WithOverlay text="overlay 1">
    Salut les amis!
</WithOverlay>


<WithOverlay text="overlay 2">
    <Button>Hover me to see</Button>
</WithOverlay>

export class TextCopyQR_backup extends React.Component{
    render() {
        var button_copy = <i className='fas fa-copy' /> 
        var button_qr = <i className="fas fa-qrcode" />

        return(
            <Fragment>
                
                <span style={{userSelect: "all"}}>
                    {this.props.value}
                </span>

                <CopyButton value={this.props.value}>
                    {button_copy}
                </CopyButton>

                <WithPopup popupcontent={getQR_JSX(this.props.value)}>
                    <ButtonDescription description="QR Code">
                        {button_qr}
                    </ButtonDescription>
                </WithPopup>

            </Fragment>
        )
    }
}
*/
